import { getNonce } from '@/api'
import { getWalletAddress, signMessage } from '@/utils/web3'

export async function loginWithWallet(store, expectedAddress = '') {
  const address = await getWalletAddress()
  if (expectedAddress && address.toLowerCase() !== expectedAddress.toLowerCase()) {
    const error = new Error('钱包地址已变化')
    error.code = 'WALLET_CHANGED'
    throw error
  }
  const nonceRes = await getNonce(address)
  if (nonceRes.code !== 0) throw new Error(nonceRes.message || '获取登录 nonce 失败')
  const message = `DApp Finance Login\nNonce: ${nonceRes.data.nonce}`
  const signature = await signMessage(message)
  if (window.ethereum && window.ethereum.request) {
    const accounts = await window.ethereum.request({ method: 'eth_accounts' })
    if (accounts[0] && accounts[0].toLowerCase() !== address.toLowerCase()) {
      const error = new Error('签名期间钱包地址已变化')
      error.code = 'WALLET_CHANGED'
      throw error
    }
  }
  return store.dispatch('login', { address, signature })
}
